import React, { useState, useEffect } from "react";
import axios from "axios";

const GoogleAuth = () => {
  const [authUrl, setAuthUrl] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [error, setError] = useState(null);

  const CLIENT_ID = "485585252174-rjn53kc0pmdcpu3mqvl03seur3jt8qmf.apps.googleusercontent.com";
  const CLIENT_SECRET = "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"; // Replace with your client secret
  const REDIRECT_URI = "https://sgbreact.solcoder.com"; // Update this with your redirect URI
  const AUTH_SCOPES = [
    "https://www.googleapis.com/auth/adwords",
    "https://www.googleapis.com/auth/tagmanager.readonly",
    "https://www.googleapis.com/auth/tagmanager.edit.containers",
    "https://www.googleapis.com/auth/tagmanager.publish",
  ];

  const AUTH_SCOPE = AUTH_SCOPES.join(" ");

  // Step 1: Generate Google Auth URL
  useEffect(() => {
    const url = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${encodeURIComponent(AUTH_SCOPE)}&access_type=offline&prompt=consent`;
    setAuthUrl(url);
  }, [CLIENT_ID, REDIRECT_URI, AUTH_SCOPE]);

  // Step 2: Handle Google Callback
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");

    if (code) {
      // Exchange Authorization Code for Access Token and Refresh Token
      const fetchTokens = async () => {
        try {
          const response = await axios.post("https://oauth2.googleapis.com/token", {
            code: code,
            client_id: CLIENT_ID,
            client_secret: CLIENT_SECRET,
            redirect_uri: REDIRECT_URI,
            grant_type: "authorization_code",
          });

          setAccessToken(response.data.access_token);
          setRefreshToken(response.data.refresh_token); // Save the refresh token
        } catch (err) {
          console.error("Error fetching tokens:", err);
          setError("Failed to exchange authorization code for tokens.");
        }
      };

      fetchTokens();
    }
	      const refreshToken = queryParams.get("token");
	 if( refreshToken ) {
		 
	 const fetchTokens2 = async () => {	 
	   const response = await axios.post("https://oauth2.googleapis.com/token", {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        refresh_token: refreshToken,
        grant_type: "refresh_token",
      });

      setAccessToken(response.data.access_token);
		   };
		 fetchTokens2();
	 }
	  
  }, [CLIENT_ID, CLIENT_SECRET, REDIRECT_URI]);

  // Step 3: Refresh Access Token
  const refreshAccessToken = async () => {
    if (!refreshToken) {
      setError("No refresh token available. Please re-authenticate.");
      return;
    }

    try {
      const response = await axios.post("https://oauth2.googleapis.com/token", {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        refresh_token: refreshToken,
        grant_type: "refresh_token",
      });

      setAccessToken(response.data.access_token);
    } catch (err) {
      console.error("Error refreshing access token:", err);
      setError("Failed to refresh access token. Please re-authenticate.");
    }
  };

  return (
    <div>
      <h1>Google OAuth Example</h1>
      {!accessToken ? (
        <div>
          <a href={authUrl}>Authenticate with Google</a>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
      ) : (
        <div>
          <h2>Access Token:</h2>
          <p>{accessToken}</p>


			<h2>Refresh Token: </h2>
			<p>{refreshToken}</p>

          <button onClick={refreshAccessToken}>Refresh Access Token</button>
        </div>
      )}
    </div>
  );
};

export default GoogleAuth;
